import React from 'react';
import { IconButton, Typography, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { useApolloClient } from '@apollo/client';
import deleteEventMakerMutation from '../../../graphql/event-maker/mutation/delete-event-maker';
import EventMakerDialog from './EventMakerDialog';
import eventMakersQuery from '../../../graphql/event-maker/query/event-maker';

const ActionMenu = ({ card, promotion, companySites, onEdit, onClose }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = React.useState(false);

  function handleClick(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  function handleDeleteClick() {
    setDeleteDialogOpen(true);
    handleClose();
  }

  function handleDeleteCancel() {
    setDeleteDialogOpen(false);
  }

  const client = useApolloClient();

  function handleDeleteConfirm() {
    client.mutate({
      mutation: deleteEventMakerMutation,
      variables: { _id: card._id },
      refetchQueries: [{ query: eventMakersQuery }],
    })
      .then(() => {
        console.log(`item with id: ${card._id} was deleted!`);
        setDeleteDialogOpen(false);
      })
      .catch((error) => {
        console.log(error);
        setDeleteDialogOpen(false);
      });
  }

  return (
    <div>
      <IconButton aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
        <MoreVertIcon color="primary" />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      >
        <MenuItem onClick={() => { onEdit(); }}>
          <Typography variant="body1" color="textSecondary">
            Edit
          </Typography>
        </MenuItem>

        <MenuItem onClick={handleDeleteClick}>
          <Typography variant="body1" color="textSecondary">
            Delete
          </Typography>
        </MenuItem>
      </Menu>

      <Dialog
        open={deleteDialogOpen}
        onClose={handleDeleteCancel}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle id="delete-dialog-title">Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-dialog-description">
            Are you sure you want to delete this event? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDeleteConfirm} color="secondary" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ActionMenu;